import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { compose, bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { loadOfferDecisionFinancedChart } from 'actions/actionCreators/offer/offerDecisionActions';
import { withTranslation } from 'react-i18next';
import { CollapseCard } from '@totalsoft/rocket-ui';
import ShowChart from '@mui/icons-material/ShowChart';
import { getFinancedChartFlags, getFinancedChart, getFolderHasMultipleAssets } from 'features/offer/edit/decision/financedChart/selectors';
import { loadFinancedOffers } from 'features/folder/edit/generalData/financedOffers/actionCreators';
import OfferDecisionFinancedAssetsChartComponent from './OfferDecisionFinancedAssetsChartComponent';
import WrappedFakeText from 'components/common/WrappedFakeText';

class OfferDecisionFinancedAssetsChartContainer extends React.PureComponent {
  componentDidMount() {
    this.loadData();
    if (this.props.folderId) this.loadFinancedOffers();
  }

  loadData = async () => {
    if (this.props.documentId && !this.props.financedChartFlags.isLoaded) {
      await this.props.actions.loadOfferDecisionFinancedChart(this.props.documentId, this.props.siteId);
    }
  };

  loadFinancedOffers = async () => {
    await this.props.actions.loadFinancedOffers(this.props.folderId, this.props.folderSiteId);
  };

  componentDidUpdate(prevProps) {
    if (
      (prevProps.financedChartFlags.isLoaded !== this.props.financedChartFlags.isLoaded && !this.props.financedChartFlags.isLoaded) ||
      prevProps.documentId !== this.props.documentId ||
      prevProps.siteId !== this.props.siteId
    ) {
      this.loadData();
    }

    if (this.props.folderId && (prevProps.folderId !== this.props.folderId || prevProps.folderSiteId !== this.props.folderSiteId)) {
      this.loadFinancedOffers();
    }
  }

  render() {
    const { financedChart, t, financedChartFlags, folderId, financedOffersLoaded, folderHasMultipleAssets } = this.props;
    return (
      <>
        {(!folderId || (financedOffersLoaded && !folderHasMultipleAssets)) && (
          <CollapseCard icon={ShowChart} title={t('OfferEdit.Decision.FinancedChart.Title')} toggleOnHeaderClick>
            {financedChartFlags.loading || !financedChartFlags.isLoaded ? (
              <WrappedFakeText lines={5} />
            ) : (
              <OfferDecisionFinancedAssetsChartComponent data={financedChart} />
            )}
          </CollapseCard>
        )}
      </>
    );
  }
}

OfferDecisionFinancedAssetsChartContainer.propTypes = {
  actions: PropTypes.object.isRequired,
  documentId: PropTypes.number.isRequired,
  siteId: PropTypes.number.isRequired,
  folderId: PropTypes.number,
  folderSiteId: PropTypes.number,
  financedChart: PropTypes.array,
  t: PropTypes.func.isRequired,
  financedChartFlags: PropTypes.object,
  financedOffersLoaded: PropTypes.bool,
  folderHasMultipleAssets: PropTypes.bool
};

function mapStateToProps(state, ownProps) {
  return {
    financedChartFlags: getFinancedChartFlags(state, ownProps),
    financedChart: getFinancedChart(state, ownProps),
    financedOffersLoaded: ownProps.folderId ? state.currentFolder.financedOffers.isLoaded : false,
    folderHasMultipleAssets: ownProps.folderId ? getFolderHasMultipleAssets(state) : false
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(
      {
        loadOfferDecisionFinancedChart,
        loadFinancedOffers
      },
      dispatch
    )
  };
}

export default compose(connect(mapStateToProps, mapDispatchToProps), withTranslation())(OfferDecisionFinancedAssetsChartContainer);
